export default "__VITE_ASSET__jBT8n1LL__"